import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getRandevular, iptalEtRandevu } from '../services/api';

// Tür rengi (eski sistemdeki renkli kutu mantığı)
const TUR_RENK = {
  'Muayene':     { bg: '#e7f0ff', fg: '#2563c9' },
  'Kontrol':     { bg: '#fff0e6', fg: '#c2570a' },
  'Laboratuvar': { bg: '#fffbe0', fg: '#9a7d00' },
  'Müdahale':    { bg: '#ffe9f3', fg: '#c93576' },
};

const bugun = () => {
  const d = new Date();
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;   // yerel tarih (UTC kayması yok)
};
const trTarih = (s) => s ? new Date(s).toLocaleDateString('tr-TR') : '—';

const ONBELLEK_ANAHTAR = 'randevular_filtre';

export default function Randevular() {
  const navigate = useNavigate();
  const kullanici = JSON.parse(localStorage.getItem('kullanici') || '{}');
  const userDokKod = kullanici.dokKod || 0;
  const siteId = kullanici.siteId || 0;
  // Layout.js'deki menü yetki mantığıyla tutarlı: hiç yetk atanmamışsa herkese açık
  const yetkVarMi = ['yetk3','yetk4','yetk6','yetk7','yetk8','yetk19','yetk20','yetk44','yetk46'].some(k => kullanici[k] === 1);
  const iptalYetkisi = !yetkVarMi || kullanici.yetk4 === 1;

  const onbellek = (() => {
    try { return JSON.parse(sessionStorage.getItem(ONBELLEK_ANAHTAR) || 'null'); } catch { return null; }
  })();

  const [bas, setBas] = useState(onbellek?.bas || bugun());
  const [bit, setBit] = useState(onbellek?.bit || bugun());
  const [liste, setListe] = useState(onbellek?.liste || []);
  const [yukleniyor, setYukleniyor] = useState(!onbellek);
  const [iptalHedef, setIptalHedef] = useState(null);   // iptal edilecek randevu
  const [gerekce, setGerekce] = useState('');
  const [iptalGonderiliyor, setIptalGonderiliyor] = useState(false);

  const yukle = useCallback((b, s) => {
    setYukleniyor(true);
    // dokKod=0 ise filtre yok (tümünü görür), değilse kendi randevularını görür
    getRandevular(b, s, userDokKod > 0 ? userDokKod : undefined)
      .then(res => {
        setListe(res.data);
        sessionStorage.setItem(ONBELLEK_ANAHTAR, JSON.stringify({ bas: b, bit: s, liste: res.data }));
      })
      .catch(() => setListe([]))
      .finally(() => setYukleniyor(false));
  }, [userDokKod]);

  useEffect(() => {
    if (!onbellek) yukle(bas, bit);
  }, []);   // eslint-disable-line react-hooks/exhaustive-deps

  const listele = (e) => { e.preventDefault(); yukle(bas, bit); };

  const iptaliOnayla = async () => {
    if (!gerekce.trim()) { alert('Lütfen iptal gerekçesini yazınız.'); return; }
    setIptalGonderiliyor(true);
    try {
      await iptalEtRandevu(siteId, iptalHedef.id, kullanici.noo || 0, kullanici.adSoyad || '', gerekce.trim());
      setIptalHedef(null);
      setGerekce('');
      yukle(bas, bit);
    } catch {
      alert('Randevu iptal edilirken bir hata oluştu.');
    } finally {
      setIptalGonderiliyor(false);
    }
  };

  // Özet: tür bazında sayım + iptal
  const aktif = liste.filter(r => !r.iptal);
  const turSayim = aktif.reduce((acc, r) => {
    const k = r.turAd || 'Diğer';
    acc[k] = (acc[k] || 0) + 1;
    return acc;
  }, {});
  const iptalSayisi = liste.length - aktif.length;

  const turBadge = (turAd) => {
    const c = TUR_RENK[turAd] || { bg: '#eef0f4', fg: '#6b7280' };
    return <span className="rozet" style={{ background: c.bg, color: c.fg }}>{turAd || '—'}</span>;
  };

  return (
    <div>
      <h1 className="sayfa-baslik">Randevular</h1>
      <p className="sayfa-alt">Tarih aralığı seçin, verilmiş randevuları listeleyin.</p>

      {/* Tarih aralığı */}
      <form onSubmit={listele} style={{ display: 'flex', gap: 12, alignItems: 'flex-end', flexWrap: 'wrap', marginBottom: 18 }}>
        <div className="form-row">
          <div className="form-label">Başlangıç</div>
          <input type="date" className="input" value={bas} onChange={e => setBas(e.target.value)} />
        </div>
        <div className="form-row">
          <div className="form-label">Bitiş</div>
          <input type="date" className="input" value={bit} onChange={e => setBit(e.target.value)} />
        </div>
        <button className="btn" type="submit">Listele</button>
      </form>

      {/* Özet kutuları */}
      {!yukleniyor && liste.length > 0 && (
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 16, alignItems: 'center' }}>
          <span className="bilgi-rozet">📊 Toplam: {aktif.length}</span>
          {Object.entries(turSayim).map(([k, v]) => {
            const c = TUR_RENK[k] || { bg: '#eef0f4', fg: '#6b7280' };
            return <span key={k} className="rozet" style={{ background: c.bg, color: c.fg }}>{k}: {v}</span>;
          })}
          {iptalSayisi > 0 && <span className="rozet" style={{ background: '#fdeaea', color: '#a32d2d' }}>İptal: {iptalSayisi}</span>}
        </div>
      )}

      <div className="kart" style={{ overflow: 'hidden' }}>
        {yukleniyor ? (
          <div className="bos-durum">Yükleniyor…</div>
        ) : liste.length === 0 ? (
          <div className="bos-durum">Bu tarih aralığında randevu bulunamadı.</div>
        ) : (
          <table className="tablo">
            <thead>
              <tr>
                <th style={{ width: 110 }}>Tarih</th>
                <th style={{ width: 70 }}>Saat</th>
                <th style={{ width: 130 }}>Tür</th>
                <th>Hasta</th>
                <th style={{ width: 150 }}>Telefon</th>
                <th style={{ width: 150 }}>Doktor</th>
                <th style={{ width: 90 }}></th>
              </tr>
            </thead>
            <tbody>
              {liste.map(r => (
                <tr key={r.id} style={r.iptal ? { opacity: .55 } : undefined}>
                  <td>{trTarih(r.tar)}</td>
                  <td style={{ fontWeight: 600 }}>{r.saat}</td>
                  <td>{turBadge(r.turAd)}</td>
                  <td>
                    {/* İsme tıklayınca → Muayene modülü (hastanın muayene geçmişi) */}
                    {r.kayitNo > 0 ? (
                      <span onClick={() => navigate(`/hasta/${r.kayitNo}/muayeneler`, { state: { from: 'randevular' } })}
                            style={{ color: 'var(--mor)', fontWeight: 600, cursor: 'pointer', textDecoration: r.iptal ? 'line-through' : 'none' }}>
                        {r.adSoy}
                      </span>
                    ) : (
                      <span style={{ fontWeight: 600, textDecoration: r.iptal ? 'line-through' : 'none' }}>{r.adSoy} <span style={{ color: 'var(--metin-soluk)', fontWeight: 400, fontSize: 12 }}>(kayıtsız)</span></span>
                    )}
                    {r.iptal && <span className="rozet" style={{ background: '#fdeaea', color: '#a32d2d', marginLeft: 8 }}>İptal</span>}
                  </td>
                  <td>{r.cepTel || '—'}</td>
                  <td style={{ color: 'var(--metin-soluk)' }}>{r.doktor || '—'}</td>
                  <td>
                    {!r.iptal && iptalYetkisi && (
                      <button className="btn-ikincil" style={{ padding: '4px 10px', fontSize: 12, color: '#a32d2d', borderColor: '#f0c4c4' }}
                              onClick={() => { setIptalHedef(r); setGerekce(''); }}>
                        İptal Et
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* İptal onay modalı */}
      {iptalHedef && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}
             onClick={() => !iptalGonderiliyor && setIptalHedef(null)}>
          <div className="kart kart-pad" style={{ width: 380, maxWidth: '90vw' }} onClick={e => e.stopPropagation()}>
            <div className="bolum-baslik" style={{ color: '#a32d2d' }}>Randevu İptali</div>
            <p style={{ fontSize: 14, margin: '10px 0' }}>
              <strong>{iptalHedef.adSoy}</strong> — {trTarih(iptalHedef.tar)} {iptalHedef.saat} randevusunu iptal etmek istiyor musunuz?
            </p>
            <div className="form-row" style={{ marginBottom: 14 }}>
              <div className="form-label">İptal Gerekçesi</div>
              <textarea className="input" rows={3} value={gerekce} onChange={e => setGerekce(e.target.value)}
                        placeholder="Lütfen iptal gerekçesini yazınız…" style={{ width: '100%', resize: 'vertical' }} />
            </div>
            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button className="btn-ikincil" onClick={() => setIptalHedef(null)} disabled={iptalGonderiliyor}>Vazgeç</button>
              <button className="btn" style={{ background: '#a32d2d' }} onClick={iptaliOnayla} disabled={iptalGonderiliyor}>
                {iptalGonderiliyor ? 'İptal ediliyor…' : 'Evet, İptal Et'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
